/**
 * 労基ルール画面用のモックデータ。
 * DB 未整備のため、一覧/編集の両画面で参照する。
 */

export type LaborRuleCategory = "標準" | "未成年" | "留学生";
export type LaborRuleKind = "所定労働時間" | "労基チェック";
export type LaborRuleStatus = "オン" | "オフ";
export type LaborRuleChangeFlag = "デフォルト" | "変更あり";

export interface ScheduledWorkHoursDetail {
    perDay: { hour: number; minute: number };
    perWeek: { hour: number; minute: number };
}

export interface LaborCheckDetail {
    perDay: { hour: number; minute: number };
    perWeek: { hour: number; minute: number };
    /** 標準のみ。未成年/留学生では未設定。 */
    perMonth?: { hour: number; minute: number };
    /** 標準のみ。未成年/留学生では未設定。 */
    consecutiveDays?: number;
}

export interface LaborRuleRow {
    id: number;
    category: LaborRuleCategory;
    kind: LaborRuleKind;
    status: LaborRuleStatus;
    changeFlag: LaborRuleChangeFlag;
    scheduledWorkHours?: ScheduledWorkHoursDetail;
    laborCheck?: LaborCheckDetail;
}

export const formatHourMinute = (hour: number, minute: number): string =>
    `${hour}時間${String(minute).padStart(2, "0")}分`;

export const MOCK_LABOR_RULE_ROWS: ReadonlyArray<LaborRuleRow> = [
    {
        id: 1,
        category: "標準",
        kind: "所定労働時間",
        status: "オン",
        changeFlag: "デフォルト",
        scheduledWorkHours: {
            perDay: { hour: 8, minute: 0 },
            perWeek: { hour: 40, minute: 0 },
        },
    },
    {
        id: 2,
        category: "標準",
        kind: "労基チェック",
        status: "オン",
        changeFlag: "デフォルト",
        laborCheck: {
            perDay: { hour: 8, minute: 0 },
            perWeek: { hour: 40, minute: 0 },
            perMonth: { hour: 160, minute: 0 },
            consecutiveDays: 6,
        },
    },
    {
        id: 3,
        category: "未成年",
        kind: "所定労働時間",
        status: "オン",
        changeFlag: "変更あり",
        scheduledWorkHours: {
            perDay: { hour: 7, minute: 0 },
            perWeek: { hour: 40, minute: 0 },
        },
    },
    {
        id: 4,
        category: "未成年",
        kind: "労基チェック",
        status: "オン",
        changeFlag: "変更あり",
        laborCheck: {
            perDay: { hour: 7, minute: 0 },
            perWeek: { hour: 40, minute: 0 },
        },
    },
    {
        id: 5,
        category: "留学生",
        kind: "所定労働時間",
        status: "オフ",
        changeFlag: "デフォルト",
        scheduledWorkHours: {
            perDay: { hour: 8, minute: 0 },
            perWeek: { hour: 28, minute: 0 },
        },
    },
    {
        id: 6,
        category: "留学生",
        kind: "労基チェック",
        status: "オフ",
        changeFlag: "デフォルト",
        laborCheck: {
            perDay: { hour: 8, minute: 0 },
            perWeek: { hour: 28, minute: 0 },
        },
    },
];

export const findLaborRuleById = (id: number): LaborRuleRow | undefined =>
    MOCK_LABOR_RULE_ROWS.find((row) => row.id === id);
